import { Collection, Q } from '@nozbe/watermelondb';

import { EntryProductModel } from '../../types/EntryProduct';
import { DBServiceOptionsWithImages } from '../../types/dbService';

class EntryProduct {
    private collection: Collection<EntryProductModel>;
    private table = 'entry_products';
    constructor(options: DBServiceOptionsWithImages) {
        this.collection = options.database.collections.get(this.table);
    }

    getNewerThan(date: number) {
        return this.collection.query(Q.where('created_at', Q.gt(date))).fetch();
    }

    getAll() {
        return this.collection.query().fetch();
    }

    getByID(id: string) {
        return this.collection.find(id);
    }

    getByParamQuery(param: string, value: any) {
        return this.collection.query(Q.where(param, value));
    }

    async getByParam(param: string, value: any) {
        return this.getByParamQuery(param, value).fetch();
    }

    async getByParamCount(param: string, value: any) {
        return this.getByParamQuery(param, value).fetchCount();
    }
}

export default EntryProduct;
